(() => {
  const desktop = window.matchMedia('(min-width: 768px)');
  const sync = () => document.querySelectorAll('.nsvc-footer-grid > details').forEach(panel => {
    panel.open = desktop.matches;
    panel.querySelector('summary')?.setAttribute('tabindex', desktop.matches ? '-1' : '0');
  });
  document.addEventListener('change', event => {
    const select = event.target;
    if (select instanceof HTMLSelectElement && select.closest('.nsvc-footer-markets') && select.form) {
      select.form.requestSubmit();
    }
  });
  sync();
  desktop.addEventListener('change', sync);
  document.addEventListener('shopify:section:load', sync);
})();

